import React from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings, ImageDescription } from '../../arc/models/arc-epi-props';


export function ClergyCompLanding() {

	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);

	const renderImageDescription = (imageDescription: ImageDescription) => {
		return (
			<DividerSection key={imageDescription?.image}>
				<div className='clergycomp-content-section'>
					{
						imageDescription?.imageOnLeft &&
						<div className='image'>
							<img src={imageDescription?.image} alt='text' />
						</div>
					}
					<div className='text rich-text' dangerouslySetInnerHTML={{ __html: imageDescription?.description }} />
					{
						!imageDescription?.imageOnLeft &&
						<div className='image'>
							<img src={imageDescription?.image} alt='text' />
						</div>
					}
				</div>
			</DividerSection>
		);

	};

	return (
		<>
			{
				settings?.imageDescription?.map(a => renderImageDescription(a))
			}
		
		</>
	);
}